// extracted by mini-css-extract-plugin
var _1 = "Control-moduleControl__QsW4M";
var _2 = "Control-moduleinput__IDrcv";
var _3 = "Control-modulelabel__Yu2zF";
export { _1 as "Control", _2 as "input", _3 as "label" }
